export const TruncateText = (text: string, length: number, withEllipsis?: boolean) => {
    if (!text) return ''
    const ellipsis = '...'
    return text.length < length ? text : `${text.substring(0, length - 3)}${ellipsis}`
}
